import React from 'react';

import { ConfirmDialog } from '@gogame/components';

const ConfirmationDialog = (props) => {
  const handleSubmit = (subject) => {
    props.onSubmit({
      subject,
    });
  };

  return (
    <ConfirmDialog
      {...props}
      withTextField={true}
      textFieldRequired={true}
      initialText={props.subject}
      bodyTextProps={{ variant: 'subtitle1' }}
      title={'Send Report to Email'}
      label={'Subject'}
      confirmActionLabel={'Send'}
      onSubmit={handleSubmit}
      minRows={2}
    />
  );
};

export default ConfirmationDialog;
